var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import PlanComparisonCell from './plan-comparison-cell.vue';
import 'core-js/features/array/includes';
import { range } from 'lodash-es';
import Tooltip from "../tooltip.vue";
var PlanComparison = /** @class */ (function (_super) {
    __extends(PlanComparison, _super);
    function PlanComparison() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selectedColumn = 1;
        _this.expanded = false;
        _this.range = range;
        // @TODO: Add the last row programmatically
        _this.shownCellsByDefault = [
            0, 1, 2, 3, 7, 8, 17
        ];
        return _this;
    }
    PlanComparison.prototype.created = function () {
        this.confirmedTechnology = this.$cookies.get('availableTechnology');
    };
    PlanComparison.prototype.mounted = function () {
        this.setupSwipeEvents();
    };
    PlanComparison.prototype.setupSwipeEvents = function () {
        var _this = this;
        this.wrapperElement = this.$refs.planComparisonWrapper;
        var touchstartX = 0;
        var touchstartY = 0;
        this.wrapperElement.addEventListener('touchstart', function (event) {
            touchstartX = event.changedTouches[0].screenX;
            touchstartY = event.changedTouches[0].screenY;
        });
        this.wrapperElement.addEventListener('touchend', function (event) {
            _this.handleSwipeEvent(touchstartX, touchstartY, event.changedTouches[0].screenX, event.changedTouches[0].screenY);
        }, false);
    };
    PlanComparison.prototype.handleSwipeEvent = function (touchstartX, touchstartY, touchendX, touchendY) {
        // Shamelessly stolen from https://gist.github.com/SleepWalker/da5636b1abcbaff48c4d#gistcomment-2577818
        var threshold = Math.max(100, Math.floor(0.25 * (window.innerWidth || document.body.clientWidth)));
        var x = touchendX - touchstartX;
        var y = touchendY - touchstartY;
        var yx = Math.abs(y / x);
        var angleLimit = Math.tan(45 * 1.5 / 180 * Math.PI);
        if (Math.abs(x) > threshold || Math.abs(y) > threshold) {
            if (yx <= angleLimit) {
                if (x < 0) {
                    if (this.selectedColumn < this.columnCount) {
                        this.selectedColumn = this.selectedColumn + 1;
                    }
                }
                else {
                    if (this.selectedColumn > 1) {
                        this.selectedColumn = this.selectedColumn - 1;
                    }
                }
            }
        }
    };
    Object.defineProperty(PlanComparison.prototype, "parsedData", {
        get: function () {
            return JSON.parse(this.data);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanComparison.prototype, "columnCount", {
        get: function () {
            if (!this.parsedData.body)
                return 0;
            // @NOTE: There are two columns that are removed on mobile
            return this.parsedData.body[0].length - 2;
        },
        enumerable: false,
        configurable: true
    });
    PlanComparison.prototype.expandColumns = function (e) {
        e.preventDefault();
        this.expanded = !this.expanded;
    };
    PlanComparison.prototype.onSelectedColumnChange = function (newVal) {
        this.$refs.comparisionTable.style.left = "calc(-".concat((newVal - 1) * 100, "% - ").concat(18.5 + ((newVal - 1) * 10), "px)");
    };
    __decorate([
        Prop({ default: '', type: String })
    ], PlanComparison.prototype, "data", void 0);
    __decorate([
        Prop({ default: -1, type: Number })
    ], PlanComparison.prototype, "recommendedColumn", void 0);
    __decorate([
        Watch('selectedColumn')
    ], PlanComparison.prototype, "onSelectedColumnChange", null);
    PlanComparison = __decorate([
        Component({
            components: {
                Tooltip: Tooltip,
                PlanComparisonCell: PlanComparisonCell,
            }
        })
    ], PlanComparison);
    return PlanComparison;
}(Vue));
export default PlanComparison;
